import type { ParticipantEmailType, CoachEmailType, PartnerEmailType, EmailPersona } from '../types';

interface EmailTypeConfig {
  label: string;
  description: string;
}

export const PARTICIPANT_EMAIL_CONFIG: Record<ParticipantEmailType, EmailTypeConfig> = {
  session_reminder: {
    label: 'Session Reminders',
    description: 'Automated reminders sent before upcoming sessions',
  },
  post_session_survey: {
    label: 'Post-Session Surveys',
    description: 'Survey emails sent after each session for participant feedback',
  },
  midpoint_survey: {
    label: 'Midpoint Surveys',
    description: 'Survey sent at the midpoint of the cohort program',
  },
  endpoint_survey: {
    label: 'Endpoint Surveys',
    description: 'Survey sent at the end of the cohort program',
  },
  survey_nudge: {
    label: 'Survey Nudges',
    description: 'Follow-up reminders for incomplete surveys',
  },
  announcement: {
    label: 'Announcements & Invitations',
    description: 'Announcement and invitation emails when finalizing and announcing modalities',
  },
  intake: {
    label: 'Intake Form Emails',
    description: 'Intake form request and reminder emails sent to participants',
  },
  pre_session_reflection: {
    label: 'Pre-Session Reflection Emails',
    description:
      'Reflection prompt (~48h before each session) and completion reminder (~18h before) for participants who have not yet submitted',
  },
};

export const COACH_EMAIL_CONFIG: Record<CoachEmailType, EmailTypeConfig> = {
  session_reminder: {
    label: 'Session Reminders',
    description: 'Automated reminders sent before upcoming sessions',
  },
  coach_post_session_survey: {
    label: 'Post-Session Surveys',
    description: 'Survey emails sent to coaches after each session',
  },
  coach_availability_request: {
    label: 'Availability Requests',
    description: 'Emails requesting coach availability for scheduling',
  },
  coach_activated: {
    label: 'Coach Activation & Announcements',
    description: 'Notifications when a coach is activated or cohort announcements',
  },
  attendance_missing: {
    label: 'Missing Attendance Alerts',
    description: 'Reminders when attendance has not been submitted',
  },
};

// MED-896: partner_survey_approval removed (dormant — no send code). Partners
// persona has zero individual email toggles; the section is hidden in the UI
// while empty (see EmailSettingsSection).
export const PARTNER_EMAIL_CONFIG: Record<PartnerEmailType, EmailTypeConfig> = {};

export const PERSONA_CONFIG: Record<EmailPersona, { label: string; description: string }> = {
  participants: {
    label: 'Participants',
    description: 'Emails sent to cohort participants',
  },
  coaches: {
    label: 'Coaches',
    description: 'Emails sent to assigned coaches',
  },
  partners: {
    label: 'Partners',
    description: 'Emails sent to partner contacts',
  },
};

export const EMAIL_CONFIG_BY_PERSONA = {
  participants: PARTICIPANT_EMAIL_CONFIG,
  coaches: COACH_EMAIL_CONFIG,
  partners: PARTNER_EMAIL_CONFIG,
} as const;
